import { State } from "./State";
import App from "../../../core/src/App";
import GameEvents from "../const/GameEvents";
import UIController from "../../src/ui/UIController";
import { UIModes, UIStates } from "../../src/ui/UIStates";
import AutoplayModel from "../model/AutoplayModel";
import SpinModel from "../model/SpinModel";
import KeyboardManager, { Key } from "../../src/utils/KeyboardManager";
import GameModel from "../model/GameModel";
import ViewManager from "../utils/ViewManager";
import { DefaultLayers } from "../utils/Layers";
import ReelGroup from "../views/ReelGroup";
import CommandManager from "../commands/CommandManager";
import { Commands } from "../commands/CommandEnum";
import PointerEvents from "../const/PointerEvents";
import Button from "../views/components/Button";
import SoundController from "../utils/SoundController";
import SoundVars from "../const/SoundVars";

export default class SpinResultState extends State {
    protected skipping: boolean;

    public enter(): void {
        super.enter();
        this.skipping = false;
        this.stopReels();
        this.checkAuto();
        this.setSkipWithSpace();
    }

    protected setSkipWithSpace() {
        if (KeyboardManager.isPressed(Key.SPACE)) {
            this.skipWithKey();
        } else {
            KeyboardManager.onKey("pressed", Key.SPACE, this.skipWithKey, this);
        }
    }

    public canExit(): boolean {
        return GameModel.canSkipSpin();
    }

    protected setUIStateOnReelStop(): void {
        UIController.setState(UIStates.SPIN_RESULT);
    }

    protected skipWithKey() {
        if(GameModel.alowSpaceToSkipSpin()) {
            if (AutoplayModel.isAutoSpinActive()) {
                CommandManager.execute(Commands.STOP_AUTOPLAY);
            } else {
                this.skip();
            }
        }
    }

    public skip() {
        if (!this.skipping) {
            // App.dispatcher.emit(GameEvents.STOP_SPIN);
            UIController.setState(UIStates.STOP_SPIN);
            let reelGroup = ViewManager.getLayer(DefaultLayers.Reels)
                .getCurrentScene()
                .getSubView("ReelGroup") as ReelGroup;
            let reels = Array.from(Array(reelGroup.reels.length).keys());
            let result = SpinModel.getStopSymbolsForReels(reels);
            reelGroup.stopImmediately(result);
            this.skipping = true;
        }
    }

    protected stopReels(delay = 0) {
        GameModel.setSpinDelay(0);
        // TO DO => This must be remove from stop reels func !!!
        this.setUIStateOnReelStop();
        App.dispatcher.once(
            GameEvents.ALL_REELS_STOPPED,
            () => {
                // SoundController.playSound(SoundVars.EFFECT_REEL_STOP);
                this.exit();
            },
            this
        );
        let reelGroup = ViewManager.getLayer(DefaultLayers.Reels)
            .getCurrentScene()
            .getSubView("ReelGroup") as ReelGroup;
        let reels = Array.from(Array(reelGroup.reels.length).keys());
        let result = SpinModel.getStopSymbolsForReels(reels);
        reelGroup.stop(result, delay);
    }

    protected checkAuto() {
        if (AutoplayModel.isAutoSpinActive()) {
            if (
                AutoplayModel.checkLossLimitReached() ||
                AutoplayModel.checkWinLimitReached(SpinModel.winAmount) ||
                AutoplayModel.checkTotalWinLimitReached() ||
                AutoplayModel.checkStopOnAnyWin(SpinModel.winAmount) ||
                AutoplayModel.checkStopOnBigWin(SpinModel.winAmount) ||
                AutoplayModel.checkFeatureWin(SpinModel.hasFreespins())
            ) {
                if (AutoplayModel.checkLossLimitReached()) {
                    let layer = ViewManager.getLayer(DefaultLayers.Popups);

                    let scene = layer.setScene("losslimit");
                    scene.interactive = true;
                    scene.buttons.forEach((button: Button) => {
                        button.on(PointerEvents.DOWN, () => {
                            SoundController.playSound(SoundVars.BUTTON_CLICK);
                            layer.completeClear();
                            UIController.setMode(UIModes.DEFAULT);
                            UIController.setState(UIStates.IDLE);
                        })
                    })
                }

                CommandManager.execute(Commands.STOP_AUTOPLAY);
                CommandManager.execute(Commands.CLEAR_AUTOPLAY_LIMITS);
            }
        }
    }

    public exit() {
        KeyboardManager.offKey("pressed", Key.SPACE, this.skipWithKey, this);
        super.exit();
    }
}
